<template>
  <div class="row">
    <el-dialog
      left
      title="Manage Stage"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="isShow"
      width="350px"
      style="margin: 0 auto;"
      @close="handleCancel"
      @open="stageDeleted=false"
      class="manageStageClass col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div
        v-for="(item,index) in stageData"
        :key="index"
        class="d-flex"
        style="margin-bottom: 10px;justify-content: space-between;"
      >
        <div
          :style="item.diligence_counts.length > 0 ?'color: #00000080;':''"
          v-b-tooltip
          :title="item.diligence_counts.length > 0?'You can not delete this stage since other companies are already existing in this stage':''"
        >{{item.stage_name}} ({{item.diligence_counts.length}})</div>

        <div v-if="item.diligence_counts.length == 0 && removeStage" @click="deleteStage(item)">
          <i class="fas fa-trash-alt handCls" style="opacity: 0.4;"></i>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      center
      title="Delete Stage"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      width="450px"
      style="margin: 0 auto;"
      :visible.sync="confirmMdlShow"
      @close="isSaving=false;confirmMdlShow=false;deleteItem={}"
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="card-body">
        <div class="inputs row">
          <p style="width: 100%; text-align: center;">Are you sure you want to delete the Stage?</p>
        </div>
        <div class="actionbuttons">
          <button
            @click.prevent="confirmMdlShow =!confirmMdlShow;deleteItem={};isSaving=false"
            class="todo-form-cancel-button btn-outline-secondary"
          >Cancel</button>
          <button
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px;"
            :disabled="isSaving"
            @click="deleteMethod"
          >
            Yes
            <b-spinner v-if="isSaving" small label="Spinning"></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import { mapGetters } from "vuex";
export default {
  components: {
    [Dialog.name]: Dialog,
  },
  computed: {
    ...mapGetters("diligence_stage", ["diligenceStageData"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    stageData() {
      let data = JSON.parse(JSON.stringify(this.diligenceStageData));
      data = data.filter((item) => item.diligence_counts);
      return data;
    },
    removeStage() {
      let featureIndex = this.getCurrentWorkspaceRolePermissions.findIndex(
        (item) => {
          if (item.toLowerCase() == "REMOVE STAGE".toLowerCase()) return item;
        }
      );
      if (featureIndex >= 0) return true;
      else return false;
    },
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
      },
    },
  },
  props: {
    value: {
      isShow: Boolean,
    },
  },
  data() {
    return {
      isSaving: false,
      deleteItem: {},
      confirmMdlShow: false,
    };
  },
  methods: {
    handleCancel() {
      let self = this;
      if (this.stageDeleted) {
        self.$parent.suggestionRefresh = false;
        setTimeout(() => {
          self.$parent.suggestionRefresh = true;
        });
      }
      this.confirmMdlShow = false;
      this.isShow = false;
      this.isSaving = false;
    },
    deleteStage(payload) {
      this.deleteItem = payload;
      this.confirmMdlShow = true;
      this.isSaving = false;
    },
    deleteMethod() {
      let self = this;
      let payload = this.deleteItem;
      this.isSaving = true;
      self.$store
        .dispatch("diligence_stage/apiDeleteStage", payload)
        .then((data) => {
          self.isSaving = false;
          self.confirmMdlShow = false;
          this.stageDeleted = true;
        })
        .catch((err) => {
          console.log("Error", { err });
        });
    },
  },
};
</script>
<style>
.deleteStagels {
  z-index: 50000;
}
</style>